module.exports = __webpack_public_path__ + "img/woman.c447b876.png";